export default "__VITE_ASSET__Bczkd_df__"